<template>
  <div class="cover-bg">
    <div class="login">
      <form action="">
        <div class="phone">
          <input
            type="text"
            placeholder="请输入手机号码"
            v-model.trim="dataForm.phone"
            @input="dataForm.phone = clearNoNum(dataForm.phone, 'decimal')"
            maxlength="11"
          />
        </div>
        <div class="verified">
          <input
            type="text"
            placeholder="请输入验证码"
            v-model.trim="dataForm.verifyCode"
            @input="dataForm.verifyCode = clearNoNum(dataForm.verifyCode, 'decimal')"
            maxlength="6" />
          <div
            :class="'get-verified' + (isDisCaptcha === true ? ' isDisCaptcha' : '')"
            @click.stop="BDtrackEvent('verifyCode2','click','verifyCode2'),(isDisCaptcha === true ? '' : getCaptcha(2))">
            {{ isDisCaptcha === true ? captchaTime + " S" : "获取验证码" }}
          </div>
        </div>
        <p class="message">*领取将自动注册，并将课程发放至账户中</p>
        <div class="submit-verified" @click.stop="submitDataForm()">
          立即领取
        </div>
      </form>
      <div class="close-login" @click="closeLogin()"></div>
    </div>
  </div>
</template>

<script>
import { isMobile } from "@/utils/validate";
export default {
  name: "phoneVerify",
  data() {
    return {
      dataForm: {
        phone: "",
        verifyCode: ""
      },
      captchaTime: 60, //验证码倒计时
      isDisCaptcha: false, //验证码是否已发
      userName: "睿识课",
      coverImgUrl: "",
      title: "",
    };
  },
  mounted() {
  },
  components: {
  },
  methods: {
    // 获取验证码
    getCaptcha() {
      let postPhone = this.dataForm.phone1
      if (postPhone === '') {
        this.$toast.fail("请输手机号码");
        return false;
      }else if (!isMobile(postPhone)) {
        this.$toast.fail("手机格式错误");
        return false;
      }
      if (this.captchaTime !== 60) {
        return false;
      } else {
        this.isDisCaptcha = true;
        // let param = { phone: postPhone };
        // getVerifyCode(param).then(({ data }) => {
        //   if (data && data.success === true) {
        //     this.$toast.success("发送成功");
        //     this['timeFlag'+type] = setInterval(() => {
        //       this['captchaTime'+type]--;
        //       if (this['captchaTime'+type] <= 0) {
        //         window.clearInterval(this['timeFlag'+type]);
        //         this['captchaTime'+type] = 60;
        //         this['isDisCaptcha'+type] = false;
        //       }
        //     }, 1000);
        //   } else {
        //     this.$toast.fail(data.message);
        //     this['isDisCaptcha'+type] = false;
        //   }
        // });
      }
    },
    // 关闭领取窗口
    closeLogin() {
      this.dataForm.phone = "";
      this.dataForm.verifyCode = "";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.cover-bg
{
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  width: 100%;
  height: 100%;

  border-radius: 1px;
  background: rgba(0, 0, 0, .69);

  .login
  {
    position: relative;

    box-sizing: border-box;
    width: 303px;
    height: 249px;
    padding: 30px 21px 24px 21px;

    border-radius: 9px;
    background: #fff;
    form
    {
      position: relative;

      display: flex;
      flex-direction: column;

      > div
      {
        position: relative;

        width: 100%;
      }
      input
      {
        font-size: 16px;
        line-height: 42px;

        box-sizing: border-box;
        height: 42px;
        padding: 5px 10px;

        color: #666;
        border: 1px solid #c0ac90; /* no*/
        border-radius: 4px;
        &:focus
        {
          font-size: 16px;
        }
      }
      .phone
      {
        input
        {
          width: 261px;
        }
      }
      .verified
      {
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: space-between;

        margin-top: 15px;
        input
        {
          width: 158px;
        }
        .get-verified
        {
          font-family: PingFangSC-Regular, PingFang SC;
          font-size: 16px;
          font-weight: 400;
          line-height: 42px;

          width: 93px;
          height: 42px;

          text-align: center;

          color: #fff;
          border-radius: 4px;
          background: linear-gradient(180deg, #ef9543 0%, #e94b2e 100%);
        }
        .isDisCaptcha
        {
          border: 1px solid #b9b9b9; /* no*/
          background: #b9b9b9;
        }
      }
      .message
      {
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;

        width: 223px;
        height: 12px;
        margin: 12px 0 25px 6px;

        color: #c6c6c6;
      }
      .submit-verified
      {
        font-family: PingFangSC-Medium, PingFang SC;
        font-size: 32px;
        font-size: 22px;
        font-weight: 500;
        line-height: 47px;

        width: 268px;
        height: 47px;

        text-align: center;
        letter-spacing: 1px;

        color: #fff;
        border-radius: 40px;
        background: url(~@assets/img/gift/button_bg@2x.png) no-repeat center;
        background-size: 100% 100%;
      }
    }
    .close-login
    {
      position: absolute;
      bottom: -60px;
      left: 50%;

      width: 30px;
      height: 30px;
      margin-left: -15px;

      cursor: pointer;

      background: url(~@assets/img/gift/delete@2x.png) no-repeat center;
      background-size: 100% 100%;
    }
  }
}

</style>
